import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { Brand } from '../../models/brand/brand-model'
import { BrandService } from '../../services/brand/brand.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router,ActivatedRoute, Params } from "@angular/router";
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';

import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { RolePermissionService } from '../../services/role/role-permission.service';

//import { CouponType } from '../../../models/coupons/coupon-type-model';
//import { CouponTypeService } from '../../../services/coupons/coupon-type.service';
//import { DiscountType } from '../../../models/coupons/discount-type-model';
//import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
@Component({
  selector: 'app-create-brand',
  templateUrl: './create-brand.component.html',
  styleUrls: ['./create-brand.component.css']
})
/** create-coupon component*/
export class CreateBrandComponent {

  public brandModel = new Brand();
  public isUnique: boolean = true;
  isSubmitted = false;
  isDisable = true;
  userId: number;
  fileToUpload: File;
  fd = new FormData();
  selectedBrandImage: string;
  profileImage = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
  isDefaultImg = true;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;
  errorMessage: any;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public mediaList: MediaLibrary[];
  mediaImageShow: boolean;
  /** create-coupon ctor */
  constructor(private readonly brandService: BrandService,
    public toastr: ToastsManager,
    private readonly router: Router,
    vcr: ViewContainerRef,
    private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService,
    private modalService: BsModalService, private readonly rolePermissionService: RolePermissionService
  ) {
    this.rolePermissionService.GetRolePermissions("brand").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.brandModel.brandID = 0;
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {

                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
          }
          else {
            this.router.navigate(["/brand-list"]);
          }
        }
        else {
          this.router.navigate(["/brand-list"]);
        }
      }
    )
  }
  openModal(template: TemplateRef<any>) {
    
    this.modalRef = this.modalService.show(template, this.config);
  }

  confirm(): void {
    this.profileImage = this.croppedImage;
    this.modalRef.hide();
  }

  decline(): void {
    this.selectedBrandImage = "";
    this.fd.delete('BrandImage');
    this.brandModel.brandLogoImage = "";
    if (this.profileImage != this.croppedImage && this.isDefaultImg) {
      this.imageChangedEvent = "";
      this.croppedImage = "";
    }
    this.modalRef.hide();
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCroppedBase64(image: string) {
    this.croppedImage = image;
    this.selectedBrandImage = image;
    this.brandModel.brandLogoImage = image;
  }
  imageLoaded() {
    this.cropperReady = true;

    //if (!this.isDefaultImg) {
    this.croppedImage = this.profileImage;
    //}
  }
  imageLoadFailed() {
    
  }
  





  uploadBrandImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("BrandImage", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedBrandImage = event.target.result;
      this.brandModel.brandLogoImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  ngSubmit() {

    //convert base 64 to file
   // this.brandModel.brandLogoImage

    this.brandService.isUniqueName(this.brandModel.brandName, this.brandModel.brandID).subscribe(
      data => {
        if (data == true) {
          this.isDisable = false;
          this.brandService.addBrand(this.brandModel, this.userId).subscribe(
            data => {

              if (data) {
                this.toastr.success('Brand has been Saved.', 'Success');
                setTimeout(() => {
                  this.router.navigate(["/brand-list"]);
                }, 2000);
              }
              else {
                this.toastr.error('Error occurred. Please try again', 'Success');
                this.isSubmitted = false;
                this.isDisable = true;
              }

            });
        }
        else {
          this.isUnique = false;
        }
      });
  }

  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.mediaImageShow = true;
    this.selectedBrandImage = "";
    this.brandModel.brandLogoImage = "";
    this.brandModel.brandLogoImage = Image.fileName;

    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.mediaImageShow = false;
    this.selectedBrandImage = "";
    this.modalRef.hide();
  }
  HidePopup() {
    this.selectedBrandImage = "";
    this.brandModel.brandLogoImage = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  ExistErrorHide() {
    this.isUnique = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/brand/create-brand/create-brand.component.ts